<template> 
    <div class="alibaba-keywords-main">
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-input v-model="params.pv" placeholder="搜索指数(>=)" class="search-item"></el-input>
                <el-input v-model="params.pvEnd" placeholder="搜索指数(<)" class="search-item"></el-input>

                <el-input v-model="params.clickRate2" placeholder="点击率(>=)" class="search-item"></el-input>
                <el-input v-model="params.clickRateEnd2" placeholder="点击率(<)" class="search-item"></el-input>

                <el-input v-model="params.resultCnt2" placeholder="卖家规模(>=)" class="search-item"></el-input>
                <el-input v-model="params.resultCntEnd2" placeholder="卖家规模(<)" class="search-item"></el-input>

                <el-input v-model="params.prr" placeholder="指数规模比(>=)" class="search-item"></el-input>
            </el-row>

            <el-row class="search-row">
                <el-input v-model="params.resultCntCrc" placeholder="卖家规模增长率(>=)" class="search-item"></el-input>
                <el-input v-model="params.resultCntCrcEnd" placeholder="卖家规模增长率(<)" class="search-item"></el-input>

                <el-date-picker
                    type="date"
                    placeholder="分析时间"
                    v-model="params.createDate"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                
                <el-input v-model="params.queryRaw" placeholder="请选择关键词(*匹配)" class="search-item"></el-input>

                <el-select class="search-item" v-model="tempLevels" multiple collapse-tags placeholder="请选择星级">
                    <el-option
                    v-for="item in levels"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                    </el-option>
                </el-select>

                <el-checkbox class="search-item" v-model="params.fltPvCrc" true-label="Y">显示指数增长</el-checkbox>

                <el-button type="primary" size="small" @click="analysis">分析</el-button>
            </el-row>
        </div>


        <div class="infinite-box" :style="'height:' + (this.$tools.mainHeight() - 105 )+ 'px'" v-infinite-scroll="next" infinite-scroll-immediate=false :infinite-scroll-disabled="disabled()"  infinite-scroll-delay="400">
            <el-card v-for="(d, index) in records" :key="index" class="alibaba-keywords-card">
                <el-row>
                    <el-col :span="16">
                        <div class="alibaba-keywords-card-flg" v-show="d.fltPvCrc == 'Y' && params.fltPvCrc == 'Y'"></div>
                        <h4>{{ d.queryRaw }}</h4>
                    </el-col>
                    <el-col :span="8"><h4><el-rate v-model="d.level" :colors="colors" @change="changeLevel(d.id, d.queryRaw, d.level)"></el-rate></h4></el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-row>搜索指数：{{ d.pv }}</el-row>
                        <el-row>点击率：{{ toPercentage(d.clickRate) }}</el-row>
                        <el-row>卖家规模：{{ d.resultCnt }} | {{ toPercentage(d.resultCntCrc) }}</el-row>
                        <el-row>日期：{{ d.createDate }}</el-row>
                    </el-col>

                    <el-col :span="14">
                        <div class="alibaba-keywords-div-out">
                            <div class="alibaba-keywords-div" v-for="(v, index) in d.trends.split(',')" :key="index" :style="getGradient(v, d.trends)" :title="v">
                                &nbsp;
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>

            <div class="totle-box" v-if="params.total > 0">
                <span v-if="params.current < params.pages">{{params.size * params.current}}/{{params.total}}</span>
                <span v-else>{{params.total}}/{{params.total}}</span>
            </div>

            <div class="infinite-box-more">
                <p v-if="!disabled()">加载中....</p>
                <p v-if="disabled()">没有更多了...</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            params: {
                createDateStart: null,
                queryKey: null,
                queryLevels: null,
                size: 15
            },
            records:[],
            tempQueryKey: [],
            tempLevels: [],
            keys: [],
            data: null,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            levels: [{key: 0, value: "未标星"},{key: 1, value: "1星"},{key: 2, value: "2星"},{key: 3, value: "3星"},{key: 4, value: "4星"},{key: 5, value: "5星"}]
        }
    },
    methods: {
        disabled() {
            return (
                this.params.current >= this.params.pages ||
                this.params.total == 0
            );
        },
        next() {
            this.params.current =
                (this.params.current ? this.params.current : 0) + 1;
            this.search();
        },

        analysis() {
            //this.params.queryKey = null;
            this.params.queryLevels = null;
            this.params.pages = 0;
            this.params.total = 0;
            this.params.current = 1;
            this.params.countId = null;
            this.records = []
            this.search()
        },

        search() {
            let _this = this;


            if (_this.tempQueryKey.length > 0) {
                _this.params.queryKey = _this.tempQueryKey.join(",")
            }

            if (_this.tempLevels.length > 0) {
                _this.params.queryLevels = _this.tempLevels.join(",")
            }

            if (_this.params.clickRate2) {
                _this.params.clickRate = _this.params.clickRate2 * 100
            }

            if (_this.params.clickRateEnd2) {
                _this.params.clickRateEnd = _this.params.clickRateEnd2 * 100
            }

            if (_this.params.resultCnt2) {
                _this.params.resultCnt = _this.params.resultCnt2 * 100
            }

            if (_this.params.resultCntEnd2) {
                _this.params.resultCntEnd = _this.params.resultCntEnd2 * 100
            }

            _this.$http.post(
                ["alibaba/keyword/analysis", _this.params],
                [
                    function (data) {
                        _this.params.pages = data.pages;
                        _this.params.total = data.total;
                        _this.params.current = data.current;
                        _this.params.countId = data.countId;
                        _this.records = _this.records.concat(data.records);
                    },
                ],
                ".alibaba-keywords-main"
            );
        },
        toPercentage(val) {
            if (!val && val != 0) {
                return 0
            } else {
                return (val / 100) + "%"
            }
        },
        getGradient(val, allVal) {
            let str = "background: linear-gradient(to bottom, transparent 0%, "
            let max = 0
            let data = allVal.split(",")

            for (var i = 0; i < data.length; i++) {
                if (window.parseInt(data[i]) > max) {
                    max = window.parseInt(data[i])
                }
            }

            if (val <= 0) {
                str += "transparent 100%);"
            } else {
                let num = window.parseFloat(val / max * 100).toFixed(4)

                str += "transparent " + (100 - num) + "%, #007ffc " +  (100 - num) + "%, #007ffc 100%);"
            }

            return str
        },
        getConfig() {
            let _this = this;

            _this.$http.post(
                ["alibaba/keyword/getKeys", {}],
                [
                    function (data) {
                        _this.keys = data.split(",")
                    },
                ],
                ".alibaba-keywords-main"
            );
        },
        changeLevel(id, key, level) {
            let _this = this;

            _this.$http.post(
                ["alibaba/keyword/updateLevels", {level: level, queryRaw: key, id: id}],
                [
                    function (data, message) {
                        message()
                    },
                ],
                ".alibaba-keywords-main"
            );
        }
    },
    mounted() {
        // this.getConfig()
    }
}
</script>

<style lang="scss" scoped>
    .alibaba-keywords-timeline {
        width: 800px;

    }
    .alibaba-keywords-card {
        margin-left:   10px;
        margin-bottom: 10px;
        width: 500px;
        float: left;
    }

    .alibaba-keywords-card-flg {
        background: #67C23A;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        float: left;
        margin-top: -14px;
        margin-left: -14px;
    }

    .alibaba-keywords-div-out {
        height: 75px;
        display: flex;
        border-bottom:1px solid #007ffc;
        width: 240px;
    }

    .alibaba-keywords-div {
        width: 10px;
        margin: 0 5px 0 5px;
        background: #007ffc;
    }

    .infinite-box {
        overflow-y: auto;
        overflow-x: hidden;
        width: 100%;

        .infinite-box-more {
            clear: both;
            text-align: center;
            font-size: 14px;
            color: #c0c4cc;
        }

        .totle-box{
            width: 50px;
            height: 24px;
            position: absolute;
            bottom: 10px;
            right: 20px;
            font-size: 12px;
            color: #c0c4cc;
        }

        .el-card__body {
            padding: 0px!important;
        }
    }
</style>